import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  CardContent,
  Grid,
  Card as MuiCard,
  LinearProgress,
  Typography,
} from "@mui/material";

import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

import {
  getNextCode,
  getLedgers,
  getFormOperationTypes,
} from "src/services/GA/gaService";
import { DefaultService } from "src/services/defaultService";
import { toast } from "react-toastify";

import { parseAndRound } from "src/utils/amUtils";
import { getCaption } from "src/utils/dictionary";
import _ from "lodash";

import AMIndexList from "src/pages/components/AMIndexList";
import GATrxFooter from "./GATrxFooter";
import LegerWithSubLedgers from "src/pages/pages/gaTrx/LegerWithSubLedgers";

const Card = styled(MuiCard)(spacing);

function GATrxPage({ menuItemCode }) {
  const defaultService = new DefaultService("GA_Trx");
  const [operationTypes, setOperationTypes] = useState([]);
  const [ledgers, setLedgers] = useState([]);

  //#region Api Calls
  const getNextCodeFunc = async () => {
    if (values && values.operationType && values.trxDate) {
      const { data } = await getNextCode(
        menuItemCode,
        values.operationType,
        values.trxDate
      );
      return data || "";
    } else return "";
  };

  const getByIdFunc = async (id) => {
    const { data } = await defaultService.get(menuItemCode, id);
   //Remove id if rendered from server to keep id as it comes from url and not enter in infinite loop
    //also if not remoced copy form will not work
    if (data) {
      delete data.id;
      delete data.ID;
      delete data.Id;
      delete data.iD;
    }
    return data;
  };

  const saveFormFunction = async (menuItemCode, formData) => {
    if (
      !(
        formControls["detailsSection"] &&
        formControls["detailsSection"].isHidden
      ) &&
      formData.trxFooter &&
      formData.trxFooter
    ) {
      const totalCredit = parseAndRound(
        _.sumBy(formData.trxFooter, function (o) {
          return parseAndRound(o.displayCredit);
        }),
        //It sums as string _.sumBy(tableData, "displayCredit"),
        4
      );
      const totalDebit = parseAndRound(
        _.sumBy(formData.trxFooter, function (o) {
          return parseAndRound(o.displayDebit);
        }),
        4
      );

      if (totalCredit !== totalDebit) {
        toast.error(getCaption("total_credit_must_equal_total_debit"));
        return false;
      }
    }

    const { data } = await defaultService.save(menuItemCode, formData);
    return data;
  };

  const deleteFunction = async (menuItemCode, formData) => {
    const { data } = await defaultService.delete(menuItemCode, formData);
    return data;
  };
  //#endRegion

  const getDefaulteValues = () => {
    const today =
      new Date().getFullYear().toString() +
      "/" +
      (new Date().getMonth() + 1).toString() +
      "/" +
      new Date().getDate().toString();

    const initialVals = { trxDate: today };
    if (operationTypes && operationTypes.length) {
      initialVals.operationType = operationTypes[0].valueField;
    }
    return initialVals;
  };

  const {
    state: values,
    errors: formErrors,
    handleSetState,
    indexColumns,
    renderFormHeader,
    renderFormInput,
    preLoaded,
    formControls,
    handleSelectedIndexChange,
  } = useForm({
    menuItemCode: menuItemCode,
    nextCodeField: "code",
    getNextCodeFunc: getNextCodeFunc,
    getByIdFunc: getByIdFunc,
    saveFunction: saveFormFunction,
    deleteFunction: deleteFunction,
    defaulteValuesFunc: getDefaulteValues,
  });

  useEffect(() => {
    /*Set Default Values */
    (async () => {
      try {
        const nextCode = await getNextCodeFunc();
        const newState = { ...values };
        newState["code"] = nextCode;
        handleSetState(newState);
      } catch (error) {
        console.log(error.message);
      }
      const { data: ot } = await getFormOperationTypes(menuItemCode);
      let OTs = [];
      try {
        OTs = JSON.parse(ot);
      } catch (error) {}

      setOperationTypes(OTs);

      const { data } = await getLedgers(menuItemCode);
      let d = [];
      try {
        d = JSON.parse(data);
      } catch (error) {}

      setLedgers(d || []);
    })();
  }, [menuItemCode]);

  // useEffect(() => {
  //   debugger;
  //   if (!operationTypes || !operationTypes.length) return;
  //   if (values.id && values.id.toLowerCase() === "add".toLowerCase()) {
  //     const newState = { ...values };
  //     debugger;
  //     newState.operationType = operationTypes[0].valueField;
  //     handleSetState(newState);
  //   }
  // }, [values.id, operationTypes]);

  //Make New Event After After PreLoad section Or Send defaulteValues as an object or function
  // useEffect(() => {
  //   try {
  //     debugger;
  //     if (
  //       preLoaded &&
  //       values.id &&
  //       values.id.toLowerCase() === "add".toLowerCase()
  //     ) {
  //       const newState = { ...values };
  //       newState["trxDate"] = "2022-08-25";
  //       handleSetState(newState);
  //     }
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // }, [preLoaded, values.id]);

  useEffect(() => {
    if (!menuItemCode || !preLoaded || !values.operationType || !values.trxDate)
      return;
    if (!values.id || values.id.toLowerCase() !== "add".toLowerCase()) return;
    /*set NextCode*/
    (async () => {
      try {
        const nextCode = await getNextCodeFunc();
        // const newState = { ...values };
        // newState["code"] = nextCode;
        handleSetState({ code: nextCode });
      } catch (error) {
        console.log(error.message);
      }
    })();
  }, [menuItemCode, preLoaded, values.operationType, values.trxDate]);

  //#region Save Details
  const handleSetTrxFooter = (newTrxFooter) => {
    const newState = { ...values };
    newState.trxFooter = [...newTrxFooter];
    handleSetState(newState);
  };
  //#endregion

  if (!preLoaded) return <LinearProgress my={2} />;

  const mainData = (
    <Card mb={6}>
      <CardContent>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid container spacing={4}>
              {renderFormInput(
                "operationType",
                Enums.ControlType.AutoComplete,
                null,
                null,
                operationTypes
              )}
              {renderFormInput("trxDate", Enums.ControlType.DatePicker)}
              {renderFormInput("code", Enums.ControlType.TextField, {
                disabled: true,
                style: { maxWidth: 100 },
              })}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={4}>
              {renderFormInput("serialNumber")}
              {renderFormInput("invoiceNumber")}
              {renderFormInput("currencyId", Enums.ControlType.AutoSearch)}
              {renderFormInput("currencyRate")}
              {renderFormInput("amount")}
              {renderFormInput("chequeNo")}
              {renderFormInput("chequeDate", Enums.ControlType.DatePicker)}
            </Grid>
          </Grid>

          {!(
            formControls["creditLedgerID"] &&
            formControls["creditLedgerID"].isHidden
          ) && (
            <>
              <Grid item xs={12}>
                <Typography variant="button" gutterBottom color="primary">
                  {(formControls["creditCaption"] &&
                    formControls["creditCaption"].caption) ||
                    "Credit"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={4}>
                  <LegerWithSubLedgers
                    ledgers={ledgers}
                    menuItemCode=""
                    formControls={formControls || {}}
                    errors={formErrors || {}}
                    onChange={handleSelectedIndexChange}
                    ledgerId={values["creditLedgerID"] || ""}
                    subLedgerAId={values["creditSubLedgerID_A"] || ""}
                    subLedgerBId={values["creditSubLedgerID_B"] || ""}
                    subLedgerCId={values["creditSubLedgerID_C"] || ""}
                    subLedgerDId={values["creditSubLedgerID_D"] || ""}
                    ledgerIdFieldName="creditLedgerID"
                    subLedgerAIdFieldName="creditSubLedgerID_A"
                    subLedgerBIdFieldName="creditSubLedgerID_B"
                    subLedgerCIdFieldName="creditSubLedgerID_C"
                    subLedgerDIdFieldName="creditSubLedgerID_D"
                  />
                </Grid>
              </Grid>
            </>
          )}
          {!(
            formControls["debitLedgerID"] &&
            formControls["debitLedgerID"].isHidden
          ) && (
            <>
              <Grid item xs={12}>
                <Typography variant="button" gutterBottom color="primary">
                  {(formControls["debitCaption"] &&
                    formControls["debitCaption"].caption) ||
                    "Debit"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={4}>
                  <LegerWithSubLedgers
                    ledgers={ledgers}
                    menuItemCode=""
                    formControls={formControls || {}}
                    errors={formErrors || {}}
                    onChange={handleSelectedIndexChange}
                    ledgerId={values["debitLedgerID"] || ""}
                    subLedgerAId={values["debitSubLedgerID_A"] || ""}
                    subLedgerBId={values["debitSubLedgerID_B"] || ""}
                    subLedgerCId={values["debitSubLedgerID_C"] || ""}
                    subLedgerDId={values["debitSubLedgerID_D"] || ""}
                    ledgerIdFieldName="debitLedgerID"
                    subLedgerAIdFieldName="debitSubLedgerID_A"
                    subLedgerBIdFieldName="debitSubLedgerID_B"
                    subLedgerCIdFieldName="debitSubLedgerID_C"
                    subLedgerDIdFieldName="debitSubLedgerID_D"
                  />
                </Grid>
              </Grid>
            </>
          )}

          {renderFormInput("notes", Enums.ControlType.TextField, null, {
            xs: 12,
            style: { paddingBottom: 5, paddingTop: 5 },
          })}
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <React.Fragment>
      {renderFormHeader()}
      {!values.id && indexColumns && !!indexColumns.length && (
        <AMIndexList
          key={indexColumns.length}
          columns={indexColumns}
          // title={title}
          // filterControls={filterControls}
          // criteria={criteria}
          // onApplyFilter={onApplyFilter}
          menuItemCode={menuItemCode}
          getAll={defaultService.getAll}
        />
      )}
      {!!values.id && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {mainData}
          </Grid>
          {!(
            formControls["detailsSection"] &&
            formControls["detailsSection"].isHidden
          ) && (
            <Grid item xs={12}>
              <GATrxFooter
                formControls={formControls}
                title="Test Footer"
                // saveRow={handleSaveRow}    I've moved this functions to the chiled component
                // deleteRow={handleDeleteRow}
                tableData={values.trxFooter || []}
                setTableData={handleSetTrxFooter}
                ledgers={ledgers}
              />
            </Grid>
          )}
        </Grid>
      )}
    </React.Fragment>
  );
}

export default GATrxPage;
